import { render } from "./clockRed.vue?vue&type=template&id=a3bab88a"
import script from "./clockRed.vue?vue&type=script&lang=js"
export * from "./clockRed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__